export default {
  getAllTokens: state => state.tokens,
}
